// components
import {
  styled,
  Paper,
  PaperProps,
  ListSubheader,
  ListSubheaderProps,
  Typography,
  TypographyProps,
  Box,
  BoxProps,
  ListItemTextProps,
  ListItemText,
  ListItemIconProps,
  ListItemIcon
} from '@mui/material';

export const StyledToolbarActionMenuPaper = styled(Paper)<PaperProps>(
  ({ theme }) => ({
    overflow: 'visible',
    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
    mt: 1.5,
    '& .MuiAvatar-root': {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1
    },
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 12,
      width: 10,
      height: 10,
      backgroundColor: theme.palette.background.paper,
      transform: 'translateY(-50%) rotate(45deg)',
      zIndex: 0
    }
  })
);

export const StyledListSubheader = styled(ListSubheader)<ListSubheaderProps>(
  ({ theme }) => ({
    lineHeight: 'normal',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  })
);

export const StyledSecondaryTypography = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    color: theme.palette.text.secondary
  })
);

export const StyledActionListItemText = styled(ListItemText)<ListItemTextProps>(
  () => ({
    lineHeight: 'normal !important'
  })
);

export const StyledActionListItemIcon = styled(ListItemIcon)<ListItemIconProps>(
  ({ theme }) => ({
    marginRight: theme.spacing(2)
  })
);

export const StyledToolbarActionMenuBox = styled(Box)<BoxProps>(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(4),
    padding: theme.spacing(0, 4)
  })
);
